import PropTypes from 'prop-types';
import {Box, Button, createStyles, Dialog, Divider, makeStyles, Theme, withStyles} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    header: {
      color: '#606B76',
      fontFamily: 'Spartan-bold',
      fontSize: 24
    }
  });

const useStyles = makeStyles(() => ({
  dialog: {
    borderRadius: '24px!important'
  },
  modalBtn: {
    width: 80,
    height: 36,
    fontFamily: 'roboto-regular',
    textTransform: 'none',
    fontSize: 16,
    marginLeft: 14,
  },
  modalBody: {
    fontFamily: 'roboto-regular',
    fontSize: 15,
    color: '#606B76',
    padding: '16px 16px 0px'
  }
}));

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>{children}</div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon style={{ fontSize: 30 }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function CreatorCloseBtnModal({
  open,
  onClose,
  onApply,
  ...rest
}: any) {

  const classes = useStyles();

  const onOK = () => {
    onApply();
  };

  const onCancel = () => {
    onClose();
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={'xs'}
      onClose={onClose}
      open={open}
      className={classes.dialog}
    >
      <div {...rest} >

        <DialogTitle onClose={onClose}>
          Are you sure you want to exit?
        </DialogTitle>

        <Divider />

        <Box className={classes.modalBody}>
          <span>Progress so far will not be saved, so you will have to start over when you are ready to resume.</span>
        </Box>

        <Box mt={3} mb={3} mr={2} display='flex' justifyContent='flex-end'>
          <Button onClick={onOK} variant="contained" color='primary' size='small' className={classes.modalBtn}>
            OK
          </Button>
          <Button onClick={onCancel} variant="contained" size='small' className={classes.modalBtn}>
            Cancel
          </Button>
        </Box>

      </div>
    </Dialog>
  );
}

CreatorCloseBtnModal.propTypes = {
  onClose: PropTypes.func,
  onApply: PropTypes.func,
  open: PropTypes.bool.isRequired,
};

CreatorCloseBtnModal.defaultProps = {
  onClose: () => { }
};

export default CreatorCloseBtnModal;
